import englishMessages from './en';
import vietnameseMessages from './vi';

const messages: any = {
  vi: vietnameseMessages,
  en: englishMessages,
};
export default messages;
